import React, { useEffect, useRef, useState } from "react";
import { Wallet, PieChart, TrendingUp } from "lucide-react";
import BudgetPlanningTracker from "../components/BudgetPlanningTracker";
import ProductExpenseTable from "../components/ProductExpenseTable";
import QuickAdd from "../components/QuickAdd/QuickAdd";
import ProgressChart from "../components/ExpenseStatement/ProgressBar";
import {
  calculateProduct,
  getBuisnessStatement,
  getCombineStats,
  getProduct,
  saveExpenseDirect,
  getExpenseActualDirect,
  getExpenseForecastDirect,
  getExpenseDeviationDirect,
  saveExpenseForecast,
  saveExpenseActual,
  deleteExpenseActual,
  deleteExpenseForecast,
  getExpenseDeviation,
  getAllExpenseCategories,
} from "../utils/ActionCreator";
import InputMUI from "../utils/InputMUI";
import "../css/classes/budgetPlanningTabs.css";
import SpinnerLoader from '../../../../../../presentationals/Loader/Loader.component';
// import SpinnerLoader from "../../../../Common/Loader.component";
import { Alert, Snackbar } from "@mui/material";
import "../components/ProductCard/ProductCard.css";
import ProductCard from "../components/ProductCard/ProductCard";
import AddProductSidebar from "../components/addProduct/AddProductSidebar";
import ExpenseStatemement from "../components/ExpenseStatement/ExpenseStatemement";
import {
  getAllExpenseCategory,
  getAllExpenseSubCategory,
} from "../../../targetactioncreator";
// import CashFlowStatement from '../components/cashflowTransaction/CashFlowStatementTable';
// import CashFlowStatement from '../components/cashflowTransaction/CashflowStatementTable';
import PlanningTabs from "../components/PlanningTabs/PlanningTabs";
import CashflowStatement from "../components/cashflowTransaction/CashflowStatement";
import DateFilter from "./DateFilter";
import TAB1 from "./TAB1";
import TAB2 from "./TAB2";
import TAB3 from "./TAB3";
import moment from "moment";
import CustomDatePicker from "../components/CustomDatePicker/CustomDatePicker";
import ThreeCards from "../components/threeCards";
import ExpenseLineChart from "../components/ExpenseStatement/ExpenseLineChart";
import ExpenseBarChart from "../components/ExpenseStatement/ExpenseBarChart";
import ExpenseForecastChart from "../components/ExpenseStatement/ExpenseForecastChart";
import ProgressGraph from "../components/ExpenseStatement/ProgressBar";
import useMockLoading from "../hooks/useMockLoading";
import { ProductTableSkeleton, CashflowStatementSkeleton, ProductCardsGridSkeleton, ExpenseTabSkeleton } from "../components/skeletons/DashboardSkeleton";

function BudgetPlanning({ chartData, admin }) {
  const [dateFilternew, setDateFilternew] = useState({
    from: moment().startOf("year").format("YYYY-MM-DD"),
    to: moment().format("YYYY-MM-DD"),
  });
  const [activeConfigTab, setActiveConfigTab] = useState("tab1");

  const [dateFilter, setDateFilter] = useState({
    fromDate: "",
    toDate: "",
    active: false,
  });

  const handleDateFilterChange = (key, value) => {
    setDateFilter((prev) => ({
      ...prev,
      [key]: value,
      active: false, // Keep active false until Apply is clicked
    }));
    console.log("Date filter updated (no fetch):", { [key]: value });
  };
  const monthlyTotals = [
    "₹ 2,600.00",
    "₹ 2,600.00",
    "₹ 2,750.00",
    "₹ 4,000.00",
    "₹ 3,100.00",
    "₹ 3,250.00",
    "₹ 3,100.00",
    "₹ 4,300.00",
    "₹ 3,250.00",
    "₹ 3,100.00",
    "₹ 3,100.00",
    "₹ 3,550.00",
    "₹ 38,700.00",
  ];

  const expenses = [
    {
      category: "Rent",
      values: Array(12).fill("₹ 1,200.00"),
      total: "₹ 14,400.00",
    },
    {
      category: "Groceries",
      values: Array(12).fill("₹ 850.00"),
      total: "₹ 10,200.00",
    },
    {
      category: "Transportation",
      values: Array(12).fill("₹ 300.00"),
      total: "₹ 3,600.00",
    },
    {
      category: "Insurance",
      values: [
        "₹ 0.00",
        "₹ 0.00",
        "₹ 150.00",
        "₹ 0.00",
        "₹ 0.00",
        "₹ 150.00",
        "₹ 0.00",
        "₹ 0.00",
        "₹ 150.00",
        "₹ 0.00",
        "₹ 0.00",
        "₹ 150.00",
      ],
      total: "₹ 600.00",
    },
    {
      category: "Clothing",
      values: Array(12).fill("₹ 200.00"),
      total: "₹ 2,400.00",
    },
    {
      category: "Body Care & Medicine",
      values: Array(12).fill("₹ 200.00"),
      total: "₹ 2,400.00",
    },
    {
      category: "Media",
      values: Array(12).fill("₹ 50.00"),
      total: "₹ 600.00",
    },
    {
      category: "Fun & Vacation",
      values: [
        "₹ 300.00",
        "₹ 300.00",
        "₹ 300.00",
        "₹ 1,200.00",
        "₹ 300.00",
        "₹ 300.00",
        "₹ 300.00",
        "₹ 1,500.00",
        "₹ 300.00",
        "₹ 300.00",
        "₹ 300.00",
        "₹ 600.00",
      ],
      total: "₹ 6,000.00",
    },
    {
      category: "",
      values: Array(12).fill(""),
      total: "₹ 0.00",
    },
    {
      category: "",
      values: Array(12).fill(""),
      total: "₹ 0.00",
    },
  ];
  const bills = [
    {
      category: "Water",
      values: Array(12).fill("₹ 1,200.00"),
      total: "₹ 14,400.00",
    },
    {
      category: "Gas",
      values: Array(12).fill("₹ 850.00"),
      total: "₹ 10,200.00",
    },
    {
      category: "Electricity",
      values: Array(12).fill("₹ 300.00"),
      total: "₹ 3,600.00",
    },
    {
      category: "Netflix",
      values: [
        "₹ 0.00",
        "₹ 0.00",
        "₹ 150.00",
        "₹ 0.00",
        "₹ 0.00",
        "₹ 150.00",
        "₹ 0.00",
        "₹ 0.00",
        "₹ 150.00",
        "₹ 0.00",
        "₹ 0.00",
        "₹ 150.00",
      ],
      total: "₹ 600.00",
    },
    {
      category: "HBO Max",
      values: Array(12).fill("₹ 200.00"),
      total: "₹ 2,400.00",
    },
    {
      category: "Disney Plus",
      values: Array(12).fill("₹ 200.00"),
      total: "₹ 2,400.00",
    },
    {
      category: "Spotify",
      values: Array(12).fill("₹ 50.00"),
      total: "₹ 600.00",
    },
  ];

  const [categoryOptions, setcategoryOptions] = useState("");
  const [subcategoryOptions, setsubcategoryOptions] = useState("");
  const [monthlyCashFlow, setMonthlyCashFlow] = useState([]);
  const [products, setProducts] = useState([]);
  const [indicatorStyle, setIndicatorStyle] = useState({});
  const [isOpenAddProduct, setIsOpenAddProduct] = useState(false);
  const [editDetails, setEditDetails] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState("P1");
  const [showCalculatePoupup, setShowCalculatePoupup] = useState(false);
  const [loader, setLoader] = useState(false);
  const [loadingCobineStats, setLoadingCombineStats] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [calculateProductPayload, setCaculateProductPayload] = useState({
    loanAprrovedAmt: "",
    countInfuse: "",
    countSchedule: "",
  });
  const [selectedMonth, setSelectedMonth] = useState(moment().format("MM"));
  const [selectedYear, setSelectedYear] = useState(moment().format("YYYY"));
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [filterFromDate, setFilterFromDate] = useState("");
  const [filterToDate, setFilterToDate] = useState("");
  const [showAddExpenseForm, setShowAddExpenseForm] = useState(false);
  const [showForecastForm, setShowForecastForm] = useState(false);
  const [showBudgetForm, setShowBudgetForm] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [expenseDate, setExpenseDate] = useState("");
  const [expenseAmount, setExpenseAmount] = useState("");
  const [expenseCategory, setExpenseCategory] = useState("");
  const [expenseSubcategory, setExpenseSubcategory] = useState("");
  const [expenseVendor, setExpenseVendor] = useState("");
  const [expensePaymentMode, setExpensePaymentMode] = useState("");
  const [expensePaymentStatus, setExpensePaymentStatus] = useState("");
  const [expenseGstApplicable, setExpenseGstApplicable] = useState("");
  const [forecastcategory, setforecastcategory] = useState("");
  const [forecastSubcategory, setforecastSubcategory] = useState("");
  const [expenseGstAmount, setExpenseGstAmount] = useState("");
  const [expenseInvoiceNo, setExpenseInvoiceNo] = useState("");
  const [expenseComment, setExpenseComment] = useState("");
  const [forecastPeriod, setForecastPeriod] = useState("monthly");
  const [forecastValue, setForecastValue] = useState("");
  const [forecastDate, setForecastDate] = useState(
    moment().format("YYYY-MM-DD"),
  );
  const [forecastMonth, setForecastMonth] = useState(moment().format("MM"));
  const [forecastYear, setForecastYear] = useState(moment().format("YYYY"));

  // State for expense date month and year dropdowns
  const [expenseMonth, setExpenseMonth] = useState(moment().format("MM"));
  const [expenseYear, setExpenseYear] = useState(moment().format("YYYY"));
  const [filterApply, setFilterApply] = useState(false);
  const [savecategoryName, setSaveCategoryName] = useState("");

  // Helper functions for month/year dropdowns
  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

   const handleReset = () => setDateFilternew({
  from: moment().startOf("year").format("YYYY-MM-DD"),
  to: moment().format("YYYY-MM-DD"),
});

  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear - 10; year <= currentYear + 10; year++) {
      years.push(year);
    }
    return years;
  };

  useEffect(() => {
    fetchProducts();
    fetchMonthlyCashFlow();
    getcategory();
    fetchCategories();
  }, []);

  const getcategory = () => {
    getAllExpenseCategory("notRequired", "", "", (callback) => {
      if (callback && callback?.status == 200) {
        setcategoryOptions(callback.data);
      } else {
        setcategoryOptions([]);
      }
    });
  };
  const handleSubcategroy = (value) => {
    getAllExpenseSubCategory("notRequired", "", "", value, (callback) => {
      setLoader(false);
      if (callback && callback?.status == 200) {
        setsubcategoryOptions(callback.data);
      } else {
        setsubcategoryOptions([]);
      }
    });
  };

  const refreshAll = () => {
    fetchProducts();
    fetchMonthlyCashFlow();
  };
  const resetCalculate = () => {
    setCaculateProductPayload({
      loanAprrovedAmt: "",
      countInfuse: "",
      countSchedule: "",
    });
  };

  const fetchProducts = () => {
    getProduct(
      (callback) => {
        if (callback.message === "success") {
          // Update noOfEmi values for specific products
          const updatedProducts = callback.data.map((product) => {
            if (product.productId === "P1") {
              return { ...product, noOfEmi: "1" };
            } else if (product.productId === "P2") {
              return { ...product, noOfEmi: "2" };
            } else if (product.productId === "P3") {
              return { ...product, noOfEmi: "3" };
            }
            return product;
          });
          setProducts(updatedProducts);
          console.log(updatedProducts);
          console.log("monthly cash flow", products);
        }
      },
      (onError) => { },
    );
  };
  const fetchMonthlyCashFlow = () => {
    getBuisnessStatement(
      (callback) => {
        if (callback.message === "success") {
          setMonthlyCashFlow(callback.data);
          console.log(callback.data);
          console.log("monthly cash flow", monthlyCashFlow);
        }
      },
      (onError) => { },
    );
  };

  const selectedProductHandler = (selectedProduct) => {
    setSelectedProduct(selectedProduct);
    setShowCalculatePoupup(true);
  };

  const resetCalculation = () => {
    setSelectedProduct("");
    setShowCalculatePoupup(false);
    resetCalculate();
  };

  const isValidForm = () => {
    if (
      calculateProductPayload.loanAprrovedAmt === "" ||
      calculateProductPayload.countInfuse === "" ||
      calculateProductPayload.countSchedule === "" ||
      loader
    ) {
      return false;
    } else {
      return true;
    }
  };

  const handleCalculate = () => {
    if (loader) {
      return;
    }
    var payload = { ...calculateProductPayload, productId: selectedProduct };
    // console.log("payload to calculate", payload);
    setLoader(true);
    calculateProduct(
      payload,
      (callback) => {
        if (callback.status === 200) {
          setSnackbar({
            open: true,
            message: "Calculation completed",
            severity: "success",
          });

          refreshAll();
          setActiveTab(tabs[0]);
          resetCalculation();
        } else {
          setSnackbar({
            open: true,
            message: callback?.data ?? "Unable to calculate, please try again",
            severity: "error",
          });
          resetCalculate();
        }

        setLoader(false);
      },
      (onErr) => {
        setSnackbar({
          open: true,
          message: "Unable to calculate, please try again",
        });
        setLoader(false);
      },
    );
  };
  const handleDeleteExpenseData = (monthIndex, rowId, cellType) => {
    console.log("🗑️ Handle delete called:", { monthIndex, rowId, cellType });

    // Extract the ID from rowId (format: "rowName_actual" or "rowName_forecast")
    const parts = rowId.split("_");
    const id = parts[parts.length - 1];
    const dataType = parts[parts.length - 2]; // 'actual' or 'forecast'

    console.log(`📋 Deleting ${dataType} data with ID: ${id}`);

    // Call appropriate delete API based on data type
    if (dataType === "forecast") {
      deleteExpenseForecast(
        id,
        (callback) => {
          console.log("✅ Forecast deleted successfully:", callback);
          setSnackbar({
            open: true,
            message: "Forecast data deleted successfully!",
            severity: "success",
          });
          // Refresh the data after deletion
          refreshAll();
        },
        (onErr) => {
          console.error("❌ Error deleting forecast:", onErr);
          setSnackbar({
            open: true,
            message:
              onErr?.response?.data?.message ||
              "Failed to delete forecast data.",
            severity: "error",
          });
        },
      );
    } else if (dataType === "actual") {
      deleteExpenseActual(
        id,
        (callback) => {
          console.log("✅ Actual expense deleted successfully:", callback);
          setSnackbar({
            open: true,
            message: "Actual expense deleted successfully!",
            severity: "success",
          });
          // Refresh the data after deletion
          refreshAll();
        },
        (onErr) => {
          console.error("❌ Error deleting actual expense:", onErr);
          setSnackbar({
            open: true,
            message:
              onErr?.response?.data?.message ||
              "Failed to delete actual expense.",
            severity: "error",
          });
        },
      );
    } else {
      console.warn("⚠️ Unknown data type for deletion:", dataType);
      setSnackbar({
        open: true,
        message: "Cannot delete: Unknown data type",
        severity: "warning",
      });
    }
  };

  // Separate handler for product deletion
  const handleDeleteProduct = (productId) => {
    console.log("Deleting product:", productId);
    // Add your delete logic here
    // You might want to show a confirmation dialog before deleting
    // and then call an API to delete the product
    setSnackbar({
      open: true,
      message: `Product ${productId} deleted successfully`,
      severity: "success",
    });
    // Refresh the products list after deletion
    fetchProducts();
  };

  const handleChange = (value, name) => {
    setCaculateProductPayload({ ...calculateProductPayload, [name]: value });
  };
  const handleTabOnAdd = () => {
    if (activeTab !== "Products") {
      setActiveTab("Products");
    }
  };
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };
  const [activeTab, setActiveTab] = useState("Business planning");

  const [activeBuisnessTab, setActiveBuisnessTab] = useState("Business");
  const [productPage, setProductPage] = useState(0);

  const mockTableLoading = useMockLoading([activeBuisnessTab, activeTab], 600);
  const tabs = [
    "Business planning",
    "Products",
    "Expense",
    // "CashFlow"
  ];

  useEffect(() => {
    updateIndicator();
  }, [activeTab]);

  const updateIndicator = () => {
    const activeTabElement = tabsRef.current[activeTab];
    if (activeTabElement) {
      const { offsetLeft, offsetWidth } = activeTabElement;
      setIndicatorStyle({
        left: `${offsetLeft}px`,
        width: `${offsetWidth}px`,
      });
    }
  };
  const tabsRef = useRef([]);
  const customWidth = {
    width: "calc(100%/3)",
  };

  const getCombineStatsApi = () => {
    setLoadingCombineStats(true);
    getCombineStats(
      (callback) => {
        refreshAll();
        setLoadingCombineStats(false);
      },
      (onErr) => {
        refreshAll();
      },
    );
  };

  useEffect(() => {
    if (!isOpenAddProduct) {
      setEditDetails(null);
      console.log("edit item in budget planning make null");
    }
  }, [isOpenAddProduct]);

  const handleMonthYearChange = (type, value) => {
    if (type === "month") {
      setSelectedMonth(value);
    } else if (type === "year") {
      setSelectedYear(value);
    }
  };

  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
  };

  const fetchCategories = () => {
    const sDate = moment().format("DD-MM-YYYY");
    const eDate = moment().add(6, "days").format("DD-MM-YYYY");

    getAllExpenseCategories(
      sDate,
      eDate,
      (response) => {
        if (response && response.data) {
          setCategories(response.data);
        }
      },
      (error) => {
        console.error("Error fetching categories:", error);
      },
    );
  };

  const applyMonthYearFilter = () => {
    try {
      setFilterApply(true);

      // Validate month and year
      if (!selectedMonth || !selectedYear) {
        setSnackbar({
          open: true,
          message: "Please select both month and year",
          severity: "warning",
        });
        return;
      }

      const firstDay = moment(`${selectedYear}-${selectedMonth}-01`)
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastDay = moment(`${selectedYear}-${selectedMonth}-01`)
        .endOf("month")
        .format("YYYY-MM-DD");

      // Validate date generation
      if (
        !firstDay ||
        !lastDay ||
        !moment(firstDay).isValid() ||
        !moment(lastDay).isValid()
      ) {
        setSnackbar({
          open: true,
          message: "Invalid date selection",
          severity: "error",
        });
        return;
      }

      setFilterFromDate(firstDay);
      setFilterToDate(lastDay);

      // Call deviation API when filter is applied
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthIndex = parseInt(selectedMonth) - 1;

      if (monthIndex < 0 || monthIndex > 11) {
        setSnackbar({
          open: true,
          message: "Invalid month selected",
          severity: "error",
        });
        return;
      }

      const monthName = monthNames[monthIndex];
      const monthForDeviation = `${monthName} ${selectedYear}`;

      console.log("📊 Calling deviation API for filter:", monthForDeviation);

      getExpenseDeviation(
        monthForDeviation,
        (callback) => {
          console.log("✅ Deviation data fetched for filter:", callback);

          // Check if data is available
          const hasData =
            callback &&
            (Array.isArray(callback)
              ? callback.length > 0
              : Object.keys(callback).length > 0);

          if (hasData) {
            window.deviationData = callback;
            setSnackbar({
              open: true,
              message: `Filter applied for ${monthNames[monthIndex]} ${selectedYear}`,
              severity: "success",
            });
          } else {
            window.deviationData = null;
            setSnackbar({
              open: true,
              message: `Filter applied for ${monthNames[monthIndex]} ${selectedYear} - No data available`,
              severity: "info",
            });
          }
        },
        (error) => {
          console.error("❌ Error fetching deviation data for filter:", error);
          window.deviationData = null;
          setSnackbar({
            open: true,
            message: "Filter applied with limited functionality",
            severity: "warning",
          });
        },
      );
    } catch (error) {
      console.error("❌ Error applying filter:", error);
      setSnackbar({
        open: true,
        message: "Error applying filter. Please try again.",
        severity: "error",
      });
    }
  };

  const clearMonthYearFilter = () => {
    try {
      console.log("🔄 Clearing filter...");

      // Reset to current month/year
      const currentMonth = moment().format("MM");
      const currentYear = moment().format("YYYY");

      console.log("📅 Resetting to:", { currentMonth, currentYear });

      // Reset all filter states
      setSelectedMonth(currentMonth);
      setSelectedYear(currentYear);
      setFilterFromDate(null); // Use null instead of empty string
      setFilterToDate(null); // Use null instead of empty string
      setFilterApply(false);

      // Clear deviation data
      window.deviationData = null;

      console.log("✅ Filter cleared successfully");
      console.log("📊 New states:", {
        selectedMonth: currentMonth,
        selectedYear: currentYear,
        filterFromDate: null,
        filterToDate: null,
        filterApply: false,
      });

      // Show success message
      setSnackbar({
        open: true,
        message: "Filter cleared - showing all data",
        severity: "info",
      });
    } catch (error) {
      console.error("❌ Error clearing filter:", error);
      setSnackbar({
        open: true,
        message: "Error clearing filter. Please refresh the page.",
        severity: "error",
      });
    }
  };

  const handleAddExpense = () => {
    //  payload for expense API matching the exact format from curl
    const expensePayload = {
      expenseDate: expenseDate || moment().format("YYYY-MM-DD"),
      month: moment(expenseDate || new Date()).format("MMM YYYY"),
      expenseAmount: parseFloat(expenseAmount) || 0,
      expenseDescription: expenseComment || "",
      category: savecategoryName || "UNCATEGORIZED",
      subCategory: expenseSubcategory || "",
      paidTo: expenseVendor || "",
      paymentMode: expensePaymentMode || "",
      paymentStatus: expensePaymentStatus || "",
      gstApplicable:
        expenseGstApplicable === "yes" ||
        expenseGstApplicable === true ||
        expenseGstApplicable === "true",
      gstAmount: parseFloat(expenseGstAmount) || 0,
      invoiceNumber: expenseInvoiceNo || "",
      createdAt: moment().format("YYYY-MM-DDTHH:mm:ss"),
    };

    console.log("💰 Adding expense:", expensePayload);
    console.log("🔍 Payload validation:", {
      hasDate: !!expenseDate,
      hasAmount: !!expenseAmount,
      hasCategory: !!savecategoryName,
      categoryName: savecategoryName,
      subCategoryName: expenseSubcategory,
      gstApplicableValue: expenseGstApplicable,
      gstApplicableBoolean:
        expenseGstApplicable === "yes" ||
        expenseGstApplicable === true ||
        expenseGstApplicable === "true",
    });

    // Call API to save expense using the new endpoint
    saveExpenseActual(
      expensePayload,
      (callback) => {
        console.log("✅ Expense saved successfully:", callback);
        setSnackbar({
          open: true,
          message: "Expense added successfully!",
          severity: "success",
        });

        // Reset form
        setSaveCategoryName("");
        setExpenseDate("");
        setExpenseAmount("");
        setExpenseCategory("");
        setExpenseSubcategory("");
        setExpenseVendor("");
        setExpensePaymentMode("");
        setExpensePaymentStatus("");
        setExpenseGstApplicable("");
        setExpenseGstAmount("");
        setExpenseInvoiceNo("");
        setExpenseComment("");
        setShowAddExpenseForm(false);

        // Refresh the expense statement data to show new entry
        if (filterFromDate && filterToDate) {
          // Trigger data refresh
        }
        const event = new CustomEvent("refreshExpenseData");
        window.dispatchEvent(event);
      },
      (onErr) => {
        console.error("❌ Error saving expense:", onErr);
        setSnackbar({
          open: true,
          message:
            onErr?.response?.data?.message ||
            onErr?.message ||
            "Failed to add expense. Please try again.",
          severity: "error",
        });
      },
    );
  };

  const handleExpenseMonthYearChange = (type, value) => {
    if (type === "month") {
      setExpenseMonth(value);
    } else {
      setExpenseYear(value);
    }

    // Update expenseDate in YYYY-MM-DD format (default to first day of month)
    const day = "01";
    const newDate = `${type === "year" ? value : expenseYear}-${type === "month" ? value : expenseMonth}-${day}`;
    setExpenseDate(newDate);
  };

  const handleForecastMonthYearChange = (type, value) => {
    if (type === "month") {
      setForecastMonth(value);
    } else {
      setForecastYear(value);
    }

    // Update forecastDate in YYYY-MM-DD format (default to first day of month)
    const day = "01";
    const newDate = `${type === "year" ? value : forecastYear}-${type === "month" ? value : forecastMonth}-${day}`;
    setForecastDate(newDate);
  };

  const handleForecast = () => {
    if (!forecastValue) {
      setSnackbar({
        open: true,
        message: "Please enter a forecast value",
        severity: "error",
      });
      return;
    }

    // Create payload for forecast API
    const forecastPayload = {
      forecastDate: forecastDate,
      forecastAmount: parseFloat(forecastValue),
      // category: expenseCategory ? expenseCategory.toUpperCase() : "GENERAL",
      category: savecategoryName ?? "",
      subCategory: forecastSubcategory ?? "",
    };

    console.log("📊 Generating forecast:", forecastPayload);

    // Call API to save forecast
    saveExpenseForecast(
      forecastPayload,
      (callback) => {
        console.log("✅ Forecast saved successfully:", callback);
        setSnackbar({
          open: true,
          message: "Forecast generated successfully!",
          severity: "success",
        });

        // Reset form
        setForecastValue("");
        setForecastDate(moment().format("YYYY-MM-DD"));
        setForecastMonth(moment().format("MM"));
        setForecastYear(moment().format("YYYY"));
        setShowForecastForm(false);

        // Refresh expense statement data to show new forecast
        const event = new CustomEvent("refreshExpenseData");
        window.dispatchEvent(event);
      },
      (onErr) => {
        console.error("❌ Error saving forecast:", onErr);
        setSnackbar({
          open: true,
          message:
            onErr?.response?.data?.message ||
            onErr?.message ||
            "Failed to generate forecast. Please try again.",
          severity: "error",
        });
      },
    );
  };

  const handlecategorychnageFn = (e) => {
    setExpenseCategory(e.target.value);
    handleSubcategroy(e.target.value);
    const ar =
      categoryOptions?.length > 0
        ? categoryOptions?.filter((el) => el?.categoryId == e.target.value)
        : [];

    setSaveCategoryName(ar?.[0]?.categoryName ?? "");
  };
  const handleforecastcategorychnageFn = (e) => {
    setforecastcategory(e.target.value);
    handleSubcategroy(e.target.value);

    const ar =
      categoryOptions?.length > 0
        ? categoryOptions?.filter((el) => el?.categoryId == e.target.value)
        : [];

    setSaveCategoryName(ar?.[0]?.categoryName ?? "");
  };

  return (
    <>
      {loadingCobineStats && <SpinnerLoader />}

      <AddProductSidebar
        refreshApi={refreshAll}
        isOpen={isOpenAddProduct}
        setIsOpen={setIsOpenAddProduct}
        handleTabOnAdd={handleTabOnAdd}
        editItem={editDetails ?? null}
        setActiveTab={setActiveTab}
      />
      {activeTab === tabs[0] ? (
        <>
          <BudgetPlanningTracker refreshAPi={fetchMonthlyCashFlow} loading={loadingCobineStats} />
          <div
            style={{
              width: "100%",
              padding: "0 90px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              boxSizing: "border-box",
            }}
          >
            <PlanningTabs
              setActiveBuisnessTab={setActiveBuisnessTab}
              activeBuisnessTab={activeBuisnessTab}
            />
            {/* Always reserve space — hide button when not on Business tab */}
            <button
              className={`calculate-btn`}
              style={{ margin: '40px 0 0 0', visibility: activeBuisnessTab === "Business" ? "visible" : "hidden" }}
              onClick={() => getCombineStatsApi()}
            >
              Combine Stats
            </button>
          </div>

          {mockTableLoading ? (
            activeBuisnessTab === "Business" ? (
              <>
                <ProductTableSkeleton />
                <ProductTableSkeleton />
              </>
            ) : (
              <div style={{ padding: "0 90px" }}>
                <CashflowStatementSkeleton />
                <CashflowStatementSkeleton />
              </div>
            )
          ) : activeBuisnessTab === "Business" ? (
            <>
              {(() => {
                const hasRealData = monthlyCashFlow && monthlyCashFlow.length > 0;
                const dataToShow = hasRealData ? monthlyCashFlow : [
                  {
                    productName: "Personal Loan",
                    monthlyData: Array.from({ length: 13 }).map((_, i) => ({
                      currentMonth: moment().startOf("year").add(i, "months").format("YYYY-MM-DD"),
                      amountInfused: "₹ 1,00,000", loanTenureMonth: "12",
                      installmentReceived: "₹ 8,500", totalAum: "₹ 1,10,000",
                      aumPercentage: "1.5%", npa: "₹ 1,500", netAumDisbursal: "₹ 98,500",
                      revenuePercentage: "12.0%", totalRevenue: "₹ 12,000",
                      processingFee: "₹ 2,000", interestFees: "₹ 9,500", penaltyAndLateFee: "₹ 500"
                    }))
                  },
                  {
                    productName: "Business Loan",
                    monthlyData: Array.from({ length: 13 }).map((_, i) => ({
                      currentMonth: moment().startOf("year").add(i, "months").format("YYYY-MM-DD"),
                      amountInfused: "₹ 1,50,000", loanTenureMonth: "24",
                      installmentReceived: "₹ 7,200", totalAum: "₹ 1,60,000",
                      aumPercentage: "2.1%", npa: "₹ 2,400", netAumDisbursal: "₹ 1,47,600",
                      revenuePercentage: "10.5%", totalRevenue: "₹ 16,800",
                      processingFee: "₹ 3,000", interestFees: "₹ 13,000", penaltyAndLateFee: "₹ 800"
                    }))
                  }
                ];

                return dataToShow.map((item, idx) => (
                  <div key={idx} style={{ marginTop: "2rem", padding: "0 90px" }}>
                    <ProductExpenseTable
                      subTitle={(item?.productName ?? "").toString()}
                      data={item?.monthlyData}
                    />
                  </div>
                ));
              })()}
            </>
          ) : (
            <div style={{ padding: "0 90px" }}>
              <CashflowStatement />
            </div>
          )}
        </>
      ) : activeTab === tabs[1] ? (
        <div
          style={{
            marginTop: "2rem",
            padding: "40px 90px",
            width: "100%",
            position: "relative",
          }}
        >
          <>
            {/* Add Product tab positioned absolutely in top right */}
            <div
              style={{
                position: "absolute",
                top: "1rem",
                right: "90px",
                zIndex: 10,
              }}
            >
              <div
                style={{
                  background: "linear-gradient(145deg, #00807a, #004d49)",
                  color: "white",
                  border: "none",
                  borderRadius: "10px",
                  padding: "8px",
                  textAlign: "center",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  boxShadow: "0 3px 8px rgba(1,92,87,0.3)",
                  minHeight: "80px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "200px",
                }}
                onClick={() => setIsOpenAddProduct(true)}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 5px 15px rgba(1,92,87,0.4)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 3px 8px rgba(1,92,87,0.3)";
                }}
              >
                <div
                  style={{
                    fontSize: "24px",
                    marginBottom: "4px",
                    opacity: "0.9",
                  }}
                >
                  +
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    marginBottom: "2px",
                  }}
                >
                  Add Product
                </div>
              </div>
            </div>

            {/* Products in their natural layout */}
            {mockTableLoading ? (
              <ProductCardsGridSkeleton />
            ) : (
              <div
                className="products-grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  width: "100%",
                  marginTop: "10rem",
                  gap: "4rem",
                }}
              >
                {products &&
                  [...products]
                    .sort((a, b) => {
                      // Set order: P1, P2, P3
                      const order = ["P1", "P2", "P3"];
                      const aIndex = order.indexOf(a.productId);
                      const bIndex = order.indexOf(b.productId);

                      // If both are in order array, sort by their position
                      if (aIndex !== -1 && bIndex !== -1) {
                        return aIndex - bIndex;
                      }
                      // If only a is in order array, it comes first
                      if (aIndex !== -1) return -1;
                      // If only b is in order array, it comes first
                      if (bIndex !== -1) return 1;
                      // If neither is in the order array, maintain original order
                      return 0;
                    })
                    .map((item, idx) => {
                      return (
                        <div key={idx}>
                          <ProductCard
                            setIsOpenAddProduct={setIsOpenAddProduct}
                            item={item}
                            handleCalculate={selectedProductHandler}
                            setEditDetails={setEditDetails}
                            handleDelete={handleDeleteProduct}
                          />
                        </div>
                      );
                    })}
              </div>
            )}
          </>
        </div>
      ) : (
        <>
          <div style={{ padding: "0 90px", width: "100%" }}>
            {/* Header with Filter on Left and Buttons on Right */}
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "transparent",
                position: "relative",
                marginBottom: "20px",
              }}
            >
              {/* Filter on the Left */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "8px",
                  background: "transparent",
                  borderRadius: "12px",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <select
                  value={selectedMonth}
                  onChange={(e) =>
                    handleMonthYearChange("month", e.target.value)
                  }
                  style={{
                    padding: "6px 10px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "12px",
                    backgroundColor: "#f8fafc",
                    minWidth: "auto",
                    height: "32px",
                    outline: "none",
                    cursor: "pointer",
                    fontWeight: "500",
                    color: "#1e293b",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#f1f5f9";
                    e.target.style.borderColor = "#cbd5e1";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#f8fafc";
                    e.target.style.borderColor = "#e2e8f0";
                  }}
                >
                  <option value="01">January</option>
                  <option value="02">February</option>
                  <option value="03">March</option>
                  <option value="04">April</option>
                  <option value="05">May</option>
                  <option value="06">June</option>
                  <option value="07">July</option>
                  <option value="08">August</option>
                  <option value="09">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                </select>

                <select
                  value={selectedYear}
                  onChange={(e) =>
                    handleMonthYearChange("year", e.target.value)
                  }
                  style={{
                    padding: "6px 10px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "12px",
                    backgroundColor: "#f8fafc",
                    minWidth: "auto",
                    height: "32px",
                    outline: "none",
                    cursor: "pointer",
                    fontWeight: "500",
                    color: "#1e293b",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#f1f5f9";
                    e.target.style.borderColor = "#cbd5e1";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#f8fafc";
                    e.target.style.borderColor = "#e2e8f0";
                  }}
                >
                  {Array.from(
                    { length: 10 },
                    (_, i) => moment().year() - i,
                  ).map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>

                <select
                  value={selectedCategory}
                  onChange={(e) => handleCategoryChange(e.target.value)}
                  style={{
                    padding: "6px 10px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "12px",
                    backgroundColor: "#f8fafc",
                    minWidth: "120px",
                    height: "32px",
                    outline: "none",
                    cursor: "pointer",
                    fontWeight: "500",
                    color: "#1e293b",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#f1f5f9";
                    e.target.style.borderColor = "#cbd5e1";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#f8fafc";
                    e.target.style.borderColor = "#e2e8f0";
                  }}
                >
                  <option value="">All Categories</option>
                  {categories &&
                    Array.isArray(categories) &&
                    categories?.length > 0
                    ? categories?.map((category, index) => {
                      return (
                        <option key={index} value={category?.categoryId}>
                          {category?.categoryName}
                        </option>
                      );
                    })
                    : ""}
                </select>
                {console.log("categories::", categories)}

              
                <button
                  onClick={applyMonthYearFilter}
                  style={{
                    padding: "6px 12px",
                    background: "radial-gradient(circle, rgb(61, 78, 109) 0%, rgb(38, 49, 69) 100%)",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    fontSize: "12px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    fontWeight: "600",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    height: "32px"
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  Apply
                </button>
                <button
                  onClick={clearMonthYearFilter}
                  style={{
                    padding: "6px 12px",
                    background: "#ffffff",
                    color: "#64748b",
                    border: "1px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "12px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    fontWeight: "600",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    height: "32px"
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = "translateY(-1px)";
                    e.target.style.background = "#f8fafc";
                    e.target.style.borderColor = "#cbd5e1";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.background = "#ffffff";
                    e.target.style.borderColor = "#e2e8f0";
                  }}
                  onMouseDown={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.background = "#e2e8f0";
                  }}
                  onMouseUp={(e) => {
                    e.target.style.transform = "translateY(-1px)";
                    e.target.style.background = "#f8fafc";
                  }}
                >
                  Reset
                </button>
              </div>
            </div>

            {/* Buttons Container on the Right */}
            <div style={{ display: "flex", gap: "12px", alignItems: "center", margin: "50px 0", padding: "0 30px" }}>
              {/* Quick Add Component */}
              <QuickAdd categories={categories} admin={admin} />
              {/* + BUDGET Button - Separate Container */}
              <div style={{
                display: "flex",
                alignItems: "center",
                background: "transparent",
                borderRadius: "10px",
                position: "relative",
                overflow: "hidden"
              }}>
                <button
                  onClick={() => setShowListModal(!showListModal)}
                  style={{
                    padding: "6px 12px",
                    background: "linear-gradient(145deg, rgb(0, 128, 122), rgb(0, 77, 73))",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "8px",
                    fontSize: "12px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    height: "32px",
                    fontWeight: "600",
                    boxShadow: "none",
                    width: "120px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    lineHeight: "1.2"
                  }}
                >
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                    marginBottom: "4px"
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M15 8a1 1 0 0 1-1-1V2a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8z" />
                      <path d="M20 8v12a2 2 0 0 1-2 2h-4.182" />
                      <path d="m3.305 19.53.923-.382" />
                      <path d="M4 10.592V4a2 2 0 0 1 2-2h8" />
                      <path d="m4.228 16.852-.924-.383" />
                      <path d="m5.852 15.228-.383-.923" />
                      <path d="m5.852 20.772-.383.924" />
                      <path d="m8.148 15.228.383-.923" />
                      <path d="m8.53 21.696-.382-.924" />
                      <path d="m9.773 16.852.922-.383" />
                      <path d="m9.773 19.148.922.383" />
                      <circle cx="7" cy="18" r="3" />
                    </svg>
                    <span>CONFIGURE</span>
                  </div>
                </button>
              </div>
            </div>
          </div>

            {mockTableLoading ? (
              <ExpenseTabSkeleton />
            ) : (
              <>
                <ThreeCards filterFromDate={filterFromDate} filterToDate={filterToDate} filterApply={filterApply} />

                <ExpenseStatemement filterFromDate={filterFromDate} filterToDate={filterToDate} filterApply={filterApply} setFilterApply={setFilterApply} style={{ marginTop: "0px" }} />

                <div className="container-fluid">
                  <div className="row">
                    <div className="col-sm-6 col-xs-12" style={{ margin: "30px 0" }}>
                      <ExpenseLineChart />
                    </div>
                    <div className="col-sm-6 col-xs-12" style={{ margin: "30px 0" }}>
                      <ExpenseBarChart />
                    </div>
                  </div>
                  <div className="row" style={{ marginBottom: "30px", display: "flex", alignItems: "stretch" }}>
                    <div className="col-sm-6 col-xs-12" style={{ margin: "10px 0", display: "flex", flexDirection: "column" }}>
                      <ExpenseForecastChart dateFilter={dateFilternew} setDateFilter={setDateFilternew} onReset={handleReset} />
                    </div>
                    <div className="col-sm-6 col-xs-12" style={{ margin: "10px 0", display: "flex", flexDirection: "column" }}>
                      <ProgressGraph data={chartData} dateFilter={dateFilternew} />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {showAddExpenseForm && (
            <div
              style={{
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                backgroundColor: "rgba(0,0,0,0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
                backdropFilter: "blur(8px)",
              }}
            >
              <div
                style={{
                  background: "#015c57",
                  borderRadius: "16px",
                  padding: "4px",
                  width: "95%",
                  maxWidth: "1200px",
                  maxHeight: "90vh",
                  overflowY: "auto",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    padding: "32px",
                    width: "100%",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                      background:
                        "radial-gradient(circle at 50% 0%, rgba(236,72,153,0.03) 0%, transparent 50%)",
                      pointerEvents: "none",
                    }}
                  ></div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "24px",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      }}
                    >
                      <div
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "12px",
                          // background: "linear-gradient(135deg, #ec4899 0%, #f43f5e 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#ffffff",
                          fontSize: "24px",
                          fontWeight: "600",
                          // boxShadow: "0 4px 16px rgba(236,72,153,0.3)"
                        }}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <line x1="12" y1="1" x2="12" y2="23"></line>
                          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                        </svg>
                      </div>
                      <div>
                        <h3
                          style={{
                            margin: "0",
                            fontSize: "20px",
                            fontWeight: "700",
                            color: "#1e293b",
                          }}
                        >
                          Add Expense
                        </h3>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#64748b",
                            fontWeight: "500",
                            marginTop: "2px",
                          }}
                        >
                          Enter expense details to track your spending
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => setShowAddExpenseForm(false)}
                      style={{
                        backgroundColor: "#f8fafc",
                        border: "1px solid #e2e8f0",
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "#64748b",
                        padding: "0",
                        width: "36px",
                        height: "36px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = "#015c57";
                        e.target.style.color = "#ffffff";
                        e.target.style.borderColor = "#015c57";
                        e.target.style.transform = "scale(1.05)";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = "#f8fafc";
                        e.target.style.color = "#64748b";
                        e.target.style.borderColor = "#e2e8f0";
                        e.target.style.transform = "scale(1)";
                      }}
                    >
                      ×
                    </button>
                  </div>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "20px",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#374151",
                          margin: "0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                        }}
                      >
                        Exp. date
                      </label>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <select
                          value={expenseMonth}
                          onChange={(e) =>
                            handleExpenseMonthYearChange(
                              "month",
                              e.target.value,
                            )
                          }
                          style={{
                            width: "60%",
                            padding: "12px 16px",
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                            fontSize: "14px",
                            outline: "none",
                            boxSizing: "border-box",
                            transition: "all 0.2s ease",
                            backgroundColor: "#ffffff",
                            fontWeight: "500",
                            color: "#1f2937",
                            cursor: "pointer",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#015c57";
                            e.target.style.backgroundColor = "#ffffff";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#015c57";
                            e.target.style.backgroundColor = "#ffffff";
                          }}
                        >
                          {months.map((month) => (
                            <option key={month.value} value={month.value}>
                              {month.label}
                            </option>
                          ))}
                        </select>
                        <select
                          value={expenseYear}
                          onChange={(e) =>
                            handleExpenseMonthYearChange("year", e.target.value)
                          }
                          style={{
                            width: "40%",
                            padding: "12px 16px",
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                            fontSize: "14px",
                            outline: "none",
                            boxSizing: "border-box",
                            transition: "all 0.2s ease",
                            backgroundColor: "#ffffff",
                            fontWeight: "500",
                            color: "#1f2937",
                            cursor: "pointer",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#015c57";
                            e.target.style.backgroundColor = "#ffffff";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#015c57";
                            e.target.style.backgroundColor = "#ffffff";
                          }}
                        >
                          {generateYears().map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#374151",
                          margin: "0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                        }}
                      >
                        Amount
                      </label>
                      <input
                        type="number"
                        value={expenseAmount}
                        onChange={(e) => setExpenseAmount(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: "1px solid #e5e7eb",
                          borderRadius: "8px",
                          fontSize: "14px",
                          outline: "none",
                          boxSizing: "border-box",
                          transition: "all 0.2s ease",
                          backgroundColor: "#ffffff",
                          fontWeight: "500",
                          color: "#1f2937",
                          fontFamily: "monospace",
                        }}
                        placeholder="Enter amount"
                        onFocus={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#374151",
                          margin: "0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                        }}
                      >
                        Category
                      </label>
                      <select
                        value={expenseCategory}
                        onChange={(e) => handlecategorychnageFn(e)}
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: "1px solid #e5e7eb",
                          borderRadius: "8px",
                          fontSize: "14px",
                          outline: "none",
                          boxSizing: "border-box",
                          transition: "all 0.2s ease",
                          backgroundColor: "#ffffff",
                          fontWeight: "500",
                          color: "#1f2937",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                      >
                        <option value="">Select category</option>
                        {categoryOptions?.length > 0
                          ? categoryOptions?.map((val, id) => {
                            return (
                              <option key={val.id} value={val.categoryId}>
                                {val.categoryName}
                              </option>
                            );
                          })
                          : ""}
                      </select>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#374151",
                          margin: "0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                        }}
                      >
                        Subcategory
                      </label>
                      <select
                        value={expenseSubcategory}
                        onChange={(e) => setExpenseSubcategory(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: "1px solid #e5e7eb",
                          borderRadius: "8px",
                          fontSize: "14px",
                          outline: "none",
                          boxSizing: "border-box",
                          transition: "all 0.2s ease",
                          backgroundColor: "#ffffff",
                          fontWeight: "500",
                          color: "#1f2937",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                      >
                        <option value="">Select SubCategory</option>
                        {subcategoryOptions?.length > 0
                          ? subcategoryOptions?.map((val, id) => {
                            return (
                              <option
                                key={val.id}
                                value={val.subCategoryName}
                              >
                                {val.subCategoryName}
                              </option>
                            );
                          })
                          : ""}
                      </select>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#374151",
                          margin: "0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                        }}
                      >
                        Paid to / Vendor
                      </label>
                      <input
                        type="text"
                        value={expenseVendor}
                        onChange={(e) => setExpenseVendor(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: "1px solid #e5e7eb",
                          borderRadius: "8px",
                          fontSize: "14px",
                          outline: "none",
                          boxSizing: "border-box",
                          transition: "all 0.2s ease",
                          backgroundColor: "#ffffff",
                          fontWeight: "500",
                          color: "#1f2937",
                        }}
                        placeholder="Enter vendor name"
                        onFocus={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#374151",
                          margin: "0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                        }}
                      >
                        Payment mode
                      </label>
                      <select
                        value={expensePaymentMode}
                        onChange={(e) => setExpensePaymentMode(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: "1px solid #e5e7eb",
                          borderRadius: "8px",
                          fontSize: "14px",
                          outline: "none",
                          boxSizing: "border-box",
                          transition: "all 0.2s ease",
                          backgroundColor: "#ffffff",
                          fontWeight: "500",
                          color: "#1f2937",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                      >
                        <option value="">Select payment mode</option>
                        <option value="cash">Cash</option>
                        <option value="card">Credit/Debit Card</option>
                        <option value="bank">Bank Transfer</option>
                        <option value="upi">UPI</option>
                        <option value="cheque">Cheque</option>
                        <option value="online">Online Payment</option>
                        <option value="other">Other</option>
                      </select>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#374151",
                          margin: "0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                        }}
                      >
                        Payment status
                      </label>
                      <select
                        value={expensePaymentStatus}
                        onChange={(e) =>
                          setExpensePaymentStatus(e.target.value)
                        }
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: "1px solid #e5e7eb",
                          borderRadius: "8px",
                          fontSize: "14px",
                          outline: "none",
                          boxSizing: "border-box",
                          transition: "all 0.2s ease",
                          backgroundColor: "#ffffff",
                          fontWeight: "500",
                          color: "#1f2937",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                      >
                        <option value="">Select payment status</option>
                        <option value="paid">Paid</option>
                        <option value="unpaid">Unpaid</option>
                        <option value="pending">Pending</option>
                        <option value="partial">Partially Paid</option>
                      </select>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#374151",
                          margin: "0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                        }}
                      >
                        GST applicable
                      </label>
                      <select
                        value={expenseGstApplicable}
                        onChange={(e) =>
                          setExpenseGstApplicable(e.target.value)
                        }
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: "1px solid #e5e7eb",
                          borderRadius: "8px",
                          fontSize: "14px",
                          outline: "none",
                          boxSizing: "border-box",
                          transition: "all 0.2s ease",
                          backgroundColor: "#ffffff",
                          fontWeight: "500",
                          color: "#1f2937",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                      >
                        <option value="">Select GST status</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>

                    {expenseGstApplicable === "yes" && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        <label
                          style={{
                            fontSize: "12px",
                            fontWeight: "600",
                            color: "#374151",
                            margin: "0",
                            textTransform: "uppercase",
                            letterSpacing: "0.8px",
                          }}
                        >
                          GST amount
                        </label>
                        <input
                          type="number"
                          value={expenseGstAmount}
                          onChange={(e) => setExpenseGstAmount(e.target.value)}
                          style={{
                            width: "100%",
                            padding: "12px 16px",
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                            fontSize: "14px",
                            outline: "none",
                            boxSizing: "border-box",
                            transition: "all 0.2s ease",
                            backgroundColor: "#ffffff",
                            fontWeight: "500",
                            color: "#1f2937",
                            fontFamily: "monospace",
                          }}
                          placeholder="Enter GST amount"
                          onFocus={(e) => {
                            e.target.style.borderColor = "#015c57";
                            e.target.style.backgroundColor = "#ffffff";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#e5e7eb";
                            e.target.style.background = "#ffffff";
                          }}
                        />
                      </div>
                    )}

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#374151",
                          margin: "0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                        }}
                      >
                        Invoice No (optional)
                      </label>
                      <input
                        type="text"
                        value={expenseInvoiceNo}
                        onChange={(e) => setExpenseInvoiceNo(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: "1px solid #e5e7eb",
                          borderRadius: "8px",
                          fontSize: "14px",
                          outline: "none",
                          boxSizing: "border-box",
                          transition: "all 0.2s ease",
                          backgroundColor: "#ffffff",
                          fontWeight: "500",
                          color: "#1f2937",
                        }}
                        placeholder="Enter invoice number"
                        onFocus={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#374151",
                          margin: "0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                        }}
                      >
                        Comment
                      </label>
                      <textarea
                        value={expenseComment}
                        onChange={(e) => setExpenseComment(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: "1px solid #e5e7eb",
                          borderRadius: "8px",
                          fontSize: "14px",
                          outline: "none",
                          boxSizing: "border-box",
                          transition: "all 0.2s ease",
                          backgroundColor: "#ffffff",
                          fontWeight: "500",
                          color: "#1f2937",
                          minHeight: "80px",
                          resize: "vertical",
                        }}
                        placeholder="Enter any additional notes or comments"
                        onFocus={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e5e7eb";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        gap: "12px",
                        justifyContent: "flex-end",
                        marginTop: "12px",
                        gridColumn: "1 / -1",
                      }}
                    >
                      <button
                        onClick={() => setShowAddExpenseForm(false)}
                        style={{
                          padding: "10px 20px",
                          background: "#ffffff",
                          color: "#64748b",
                          border: "1px solid #e2e8f0",
                          borderRadius: "8px",
                          fontSize: "13px",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          height: "40px",
                          fontWeight: "600",
                          minWidth: "100px",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                        onMouseOver={(e) => {
                          e.target.style.transform = "translateY(-1px)";
                          e.target.style.background = "#f8fafc";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.transform = "translateY(0)";
                          e.target.style.background = "#ffffff";
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleAddExpense}
                        style={{
                          padding: "10px 20px",
                          background: "#015c57",
                          color: "#ffffff",
                          border: "none",
                          borderRadius: "8px",
                          fontSize: "13px",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          height: "40px",
                          fontWeight: "600",
                          boxShadow: "none",
                          minWidth: "120px",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                        onMouseOver={(e) => {
                          e.target.style.transform = "translateY(-1px)";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.transform = "translateY(0)";
                        }}
                      >
                        Add Expense
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showForecastForm && (
            <div
              style={{
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                backgroundColor: "rgba(0,0,0,0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
                backdropFilter: "blur(8px)",
              }}
            >
              <div
                style={{
                  background: "#015c57",
                  borderRadius: "16px",
                  padding: "4px",
                  width: "90%",
                  maxWidth: "520px",
                  boxShadow: "none",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    padding: "32px",
                    width: "100%",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                      background:
                        "radial-gradient(circle at 50% 0%, rgba(6,182,212,0.03) 0%, transparent 50%)",
                      pointerEvents: "none",
                    }}
                  ></div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "24px",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      }}
                    >
                      {/* <div style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "12px",
                          background: "linear-gradient(135deg, #06b6d4 0%, #0ea5e9 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#ffffff",
                          fontSize: "24px",
                          fontWeight: "600",
                          boxShadow: "0 4px 16px rgba(6,182,212,0.3)"
                        }}>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                          </svg>
                        </div> */}
                      <div>
                        <h3
                          style={{
                            margin: "0",
                            fontSize: "20px",
                            fontWeight: "700",
                            color: "#1e293b",
                          }}
                        >
                          Add Forecast
                        </h3>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#64748b",
                            fontWeight: "500",
                            marginTop: "2px",
                          }}
                        >
                          Configure forecast parameters for planning
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => setShowForecastForm(false)}
                      style={{
                        backgroundColor: "#f8fafc",
                        border: "1px solid #e2e8f0",
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "#64748b",
                        padding: "0",
                        width: "36px",
                        height: "36px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = "#015c57";
                        e.target.style.color = "#ffffff";
                        e.target.style.borderColor = "#015c57";
                        e.target.style.transform = "scale(1.05)";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = "#f8fafc";
                        e.target.style.color = "#64748b";
                        e.target.style.borderColor = "#e2e8f0";
                        e.target.style.transform = "scale(1)";
                      }}
                    >
                      ×
                    </button>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "20px",
                      position: "relative",
                    }}
                  >
                    {/* <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        <label style={{ 
                          fontSize: "12px", 
                          fontWeight: "600", 
                          color: "#374151", 
                          margin: "0", 
                          textTransform: "uppercase", 
                          letterSpacing: "0.8px"
                        }}>
                          Forecast Period
                        </label>
                        <select
                          value={forecastPeriod}
                          onChange={(e) => setForecastPeriod(e.target.value)}
                          style={{
                            width: "100%",
                            padding: "12px 16px",
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                            fontSize: "14px",
                            outline: "none",
                            boxSizing: "border-box",
                            transition: "all 0.2s ease",
                            backgroundColor: "#ffffff",
                            cursor: "pointer",
                            fontWeight: "500",
                            color: "#1f2937",
                                                      }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#015c57";
                            e.target.style.backgroundColor = "#ffffff";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#015c57";
                            e.target.style.backgroundColor = "#ffffff";
                          }}
                        >
                          <option value="monthly">Monthly</option>
                          <option value="quarterly">Quarterly</option>
                          <option value="yearly">Yearly</option>
                        </select>
                      </div> */}

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#374151",
                          margin: "0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                        }}
                      >
                        Category
                      </label>
                      <select
                        value={forecastcategory}
                        onChange={(e) => {
                          handleforecastcategorychnageFn(e);
                        }}
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: "1px solid #e5e7eb",
                          borderRadius: "8px",
                          fontSize: "14px",
                          outline: "none",
                          boxSizing: "border-box",
                          transition: "all 0.2s ease",
                          backgroundColor: "#ffffff",
                          fontWeight: "500",
                          color: "#1f2937",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                      >
                        <option value="">Select category</option>
                        {categoryOptions?.length > 0
                          ? categoryOptions?.map((val, id) => {
                            return (
                              <option key={val.id} value={val.categoryId}>
                                {val.categoryName}
                              </option>
                            );
                          })
                          : ""}
                      </select>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#374151",
                          margin: "0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                        }}
                      >
                        Subcategory
                      </label>
                      <select
                        value={forecastSubcategory}
                        onChange={(e) => setforecastSubcategory(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: "1px solid #e5e7eb",
                          borderRadius: "8px",
                          fontSize: "14px",
                          outline: "none",
                          boxSizing: "border-box",
                          transition: "all 0.2s ease",
                          backgroundColor: "#ffffff",
                          fontWeight: "500",
                          color: "#1f2937",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                      >
                        <option value="">Select SubCategory</option>
                        {subcategoryOptions?.length > 0
                          ? subcategoryOptions?.map((val, id) => {
                            return (
                              <option
                                key={val.id}
                                value={val.subCategoryName}
                              >
                                {val.subCategoryName}
                              </option>
                            );
                          })
                          : ""}
                      </select>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#374151",
                          margin: "0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                        }}
                      >
                        Month & Year
                      </label>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <select
                          value={forecastMonth}
                          onChange={(e) =>
                            handleForecastMonthYearChange(
                              "month",
                              e.target.value,
                            )
                          }
                          style={{
                            width: "50%",
                            padding: "12px 16px",
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                            fontSize: "14px",
                            outline: "none",
                            boxSizing: "border-box",
                            transition: "all 0.2s ease",
                            backgroundColor: "#ffffff",
                            fontWeight: "500",
                            color: "#1f2937",
                            cursor: "pointer",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#015c57";
                            e.target.style.backgroundColor = "#ffffff";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#015c57";
                            e.target.style.backgroundColor = "#ffffff";
                          }}
                        >
                          {months.map((month) => (
                            <option key={month.value} value={month.value}>
                              {month.label}
                            </option>
                          ))}
                        </select>
                        <select
                          value={forecastYear}
                          onChange={(e) =>
                            handleForecastMonthYearChange(
                              "year",
                              e.target.value,
                            )
                          }
                          style={{
                            width: "50%",
                            padding: "12px 16px",
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                            fontSize: "14px",
                            outline: "none",
                            boxSizing: "border-box",
                            transition: "all 0.2s ease",
                            backgroundColor: "#ffffff",
                            fontWeight: "500",
                            color: "#1f2937",
                            cursor: "pointer",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#015c57";
                            e.target.style.backgroundColor = "#ffffff";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#015c57";
                            e.target.style.backgroundColor = "#ffffff";
                          }}
                        >
                          {generateYears().map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#374151",
                          margin: "0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                        }}
                      >
                        Forecast
                      </label>
                      <input
                        type="text"
                        value={forecastValue}
                        onChange={(e) => setForecastValue(e.target.value)}
                        placeholder="Enter forecast value"
                        style={{
                          width: "100%",
                          padding: "12px 16px",
                          border: "1px solid #e5e7eb",
                          borderRadius: "8px",
                          fontSize: "14px",
                          outline: "none",
                          boxSizing: "border-box",
                          transition: "all 0.2s ease",
                          backgroundColor: "#ffffff",
                          fontWeight: "500",
                          color: "#1f2937",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#015c57";
                          e.target.style.backgroundColor = "#ffffff";
                        }}
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        gap: "12px",
                        justifyContent: "flex-end",
                        marginTop: "12px",
                      }}
                    >
                      <button
                        onClick={() => setShowForecastForm(false)}
                        style={{
                          padding: "10px 20px",
                          background: "#ffffff",
                          color: "#64748b",
                          border: "1px solid #e2e8f0",
                          borderRadius: "8px",
                          fontSize: "13px",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          height: "40px",
                          fontWeight: "600",
                          minWidth: "100px",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                        onMouseOver={(e) => {
                          e.target.style.transform = "translateY(-1px)";
                          e.target.style.background = "#f8fafc";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.transform = "translateY(0)";
                          e.target.style.background = "#ffffff";
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleForecast}
                        style={{
                          padding: "10px 20px",
                          background: "#015c57",
                          color: "#ffffff",
                          border: "none",
                          borderRadius: "8px",
                          fontSize: "13px",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          height: "40px",
                          fontWeight: "600",
                          boxShadow: "0 4px 12px rgba(1,92,87,0.3)",
                          minWidth: "120px",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                        onMouseOver={(e) => {
                          e.target.style.transform = "translateY(-1px)";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.transform = "translateY(0)";
                        }}
                      >
                        Add Forecast
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showListModal && (
            <div
              style={{
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                backgroundColor: "rgba(0,0,0,0.8)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
                backdropFilter: "blur(8px)",
              }}
            >
              <div
                style={{
                  background: "#ffffff",
                  borderRadius: "16px",
                  width: "100%",
                  height: "100vh",
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "0 25px 50px rgba(0,0,0,0.3)",
                  overflow: "hidden",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #015c57 0%, #0a7d75 100%)",
                    color: "white",
                    padding: "24px 32px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  <div>
                    <h2
                      style={{
                        margin: "0",
                        fontSize: "24px",
                        fontWeight: "600",
                      }}
                    >
                      Configure
                    </h2>
                    <p
                      style={{
                        margin: "8px 0 0 0",
                        fontSize: "14px",
                        opacity: "0.9",
                      }}
                    >
                      Manage and configure your expenses{" "}
                    </p>
                  </div>
                  <button
                    onClick={() => setShowListModal(false)}
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      border: "none",
                      borderRadius: "50%",
                      width: "40px",
                      height: "40px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      fontSize: "20px",
                      color: "white",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.background = "rgba(255,255,255,0.3)";
                      e.target.style.transform = "scale(1.1)";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.background = "rgba(255,255,255,0.2)";
                      e.target.style.transform = "scale(1)";
                    }}
                  >
                    ×
                  </button>
                </div>

                {/* Content */}
                <div
                  style={{
                    flex: 1,
                    padding: "32px",
                    overflow: "auto",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* Tabs Navigation */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderBottom: "1px solid #e2e8f0",
                      marginBottom: "24px",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <button
                        style={{
                          padding: "12px 24px",
                          background: "transparent",
                          color:
                            activeConfigTab === "tab1" ? "#015c57" : "#64748b",
                          border: "none",
                          borderBottom:
                            activeConfigTab === "tab1"
                              ? "2px solid #015c57"
                              : "2px solid transparent",
                          fontSize: "14px",
                          fontWeight: "600",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                        onClick={() => setActiveConfigTab("tab1")}
                      >
                        Expense Category
                      </button>
                      <button
                        style={{
                          padding: "12px 24px",
                          background: "transparent",
                          color:
                            activeConfigTab === "tab2" ? "#015c57" : "#64748b",
                          border: "none",
                          borderBottom:
                            activeConfigTab === "tab2"
                              ? "2px solid #015c57"
                              : "2px solid transparent",
                          fontSize: "14px",
                          fontWeight: "600",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                        onClick={() => setActiveConfigTab("tab2")}
                      >
                        Expense Sub-Category
                      </button>
                      <button
                        style={{
                          padding: "12px 24px",
                          background: "transparent",
                          color:
                            activeConfigTab === "tab3" ? "#015c57" : "#64748b",
                          border: "none",
                          borderBottom:
                            activeConfigTab === "tab3"
                              ? "2px solid #015c57"
                              : "2px solid transparent",
                          fontSize: "14px",
                          fontWeight: "600",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                        onClick={() => setActiveConfigTab("tab3")}
                      >
                        Expense-Description
                      </button>
                    </div>

                    {/* Configure Date Filter on Right Side */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        background: "#f8fafc",
                        border: "1px solid #e2e8f0",
                        borderRadius: "12px",
                        padding: "8px 16px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#64748b"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <rect
                            x="3"
                            y="4"
                            width="18"
                            height="18"
                            rx="2"
                            ry="2"
                          />
                          <line x1="16" y1="2" x2="16" y2="6" />
                          <line x1="8" y1="2" x2="8" y2="6" />
                          <line x1="3" y1="10" x2="21" y2="10" />
                        </svg>
                        <span
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#64748b",
                          }}
                        >
                          From:
                        </span>
                        <CustomDatePicker
                          key={`from-${dateFilter?.fromDate || "empty"}`}
                          value={dateFilter?.fromDate || ""}
                          onChange={(value) =>
                            handleDateFilterChange("fromDate", value)
                          }
                          placeholder="Select from date"
                          style={{
                            padding: "8px 12px",
                            border: "2px solid #e2e8f0",
                            borderRadius: "10px",
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#1e293b",
                            background:
                              "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                            outline: "none",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            cursor: "pointer",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                            fontFamily: "system-ui, -apple-system, sans-serif",
                            letterSpacing: "0.2px",
                            width: "140px",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#64748b",
                          }}
                        >
                          To:
                        </span>
                        <CustomDatePicker
                          key={`to-${dateFilter?.toDate || "empty"}`}
                          value={dateFilter?.toDate || ""}
                          onChange={(value) =>
                            handleDateFilterChange("toDate", value)
                          }
                          placeholder="Select to date"
                          style={{
                            padding: "8px 12px",
                            border: "2px solid #e2e8f0",
                            borderRadius: "10px",
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#1e293b",
                            background:
                              "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                            outline: "none",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            cursor: "pointer",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                            fontFamily: "system-ui, -apple-system, sans-serif",
                            letterSpacing: "0.2px",
                            width: "140px",
                          }}
                        />
                      </div>

                      <button
                        onClick={() => {
                          // Apply date filter
                          if (dateFilter?.fromDate && dateFilter?.toDate) {
                            // Set active state to true
                            setDateFilter((prev) => ({
                              ...prev,
                              active: true,
                            }));
                            // The tabs will automatically pick up the updated dateFilter
                          }
                        }}
                        style={{
                          padding: "6px 16px",
                          background:
                            "linear-gradient(135deg, #015c57 0%, #0a7d75 100%)",
                          color: "#ffffff",
                          border: "none",
                          borderRadius: "8px",
                          fontSize: "13px",
                          fontWeight: "600",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          boxShadow: "0 2px 4px rgba(1, 92, 87, 0.2)",
                        }}
                        onMouseOver={(e) => {
                          e.target.style.transform = "translateY(-1px)";
                          e.target.style.boxShadow =
                            "0 4px 8px rgba(1, 92, 87, 0.3)";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.transform = "translateY(0)";
                          e.target.style.boxShadow =
                            "0 2px 4px rgba(1, 92, 87, 0.2)";
                        }}
                      >
                        Apply
                      </button>

                      <button
                        onClick={() => {
                          // Reset date filter
                          setDateFilter({
                            fromDate: "",
                            toDate: "",
                            active: false,
                          });
                        }}
                        style={{
                          padding: "6px 16px",
                          background: "#f1f5f9",
                          color: "#64748b",
                          border: "1px solid #e2e8f0",
                          borderRadius: "8px",
                          fontSize: "13px",
                          fontWeight: "600",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                        onMouseOver={(e) => {
                          e.target.style.background = "#e2e8f0";
                          e.target.style.color = "#475569";
                        }}
                        onMouseOut={(e) => {
                          e.target.style.background = "#f1f5f9";
                          e.target.style.color = "#64748b";
                        }}
                      >
                        Reset
                      </button>
                    </div>
                  </div>

                  {/* Tab Content */}
                  {activeConfigTab === "tab1" && (
                    <TAB1 dateFilter={dateFilter} />
                  )}
                  {activeConfigTab === "tab2" && (
                    <TAB2 dateFilter={dateFilter} />
                  )}
                  {activeConfigTab === "tab3" && (
                    <TAB3 dateFilter={dateFilter} />
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      )}


      {showCalculatePoupup &&

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-6 col-xs-12" style={{ margin: "10px 0" }}>
              <ExpenseLineChart />
            </div>
            <div className="col-sm-6 col-xs-12" style={{ margin: "10px 0" }}>
              <ExpenseBarChart />
            </div>
          </div>
          <div className="row" style={{ marginBottom: "40px", display: "flex", alignItems: "stretch" }}>
            <div className="col-sm-6 col-xs-12" style={{ margin: "10px 0", display: "flex", flexDirection: "column" }}>
              <ExpenseForecastChart
                
                />
            </div>
            <div className="col-sm-6 col-xs-12" style={{ margin: "10px 0", display: "flex", flexDirection: "column" }}>
              <ProgressGraph data={chartData} />
            </div>
          </div>
        </div>
      }
      {showCalculatePoupup && (
        <>
          <style>
            {`
              body {
                overflow: hidden !important;
              }
            `}
          </style>
          <div style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            backdropFilter: 'blur(8px)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                boxShadow: '0 25px 50px rgba(0, 0, 0, 0.15)',
                maxWidth: '520px',
                width: '90%',
                maxHeight: '85vh',
                overflow: 'auto',
                position: 'relative',
                border: '1px solid #e2e8f0',
                animation: 'modalSlideIn 0.3s ease-out'
              }}
            >
              {/* Header */}
              <div style={{
                padding: '24px 24px 20px',
                borderBottom: '1px solid #f1f5f9',
                background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
                borderRadius: '16px 16px 0 0'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '16px'
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <div style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '12px',
                      background: 'linear-gradient(135deg, #015c57, #0a7d75)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 4px 12px rgba(1, 92, 87, 0.25)'
                    }}>
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                        <line x1="9" y1="9" x2="15" y2="9"/>
                        <line x1="9" y1="15" x2="15" y2="15"/>
                      </svg>
                    </div>
                    <div>
                      <h2 style={{
                        margin: 0,
                        fontSize: '20px',
                        fontWeight: '700',
                        color: '#1e293b',
                        letterSpacing: '-0.025em'
                      }}>Calculate Product</h2>
                      <p style={{
                        margin: '2px 0 0',
                        fontSize: '13px',
                        color: '#64748b',
                        lineHeight: '1.4'
                      }}>Enter loan details to calculate product metrics</p>
                    </div>
                  </div>
                  <button
                    onClick={() => {
                      resetCalculation();
                    }}
                    style={{
                      width: '36px',
                      height: '36px',
                      borderRadius: '50%',
                      backgroundColor: '#f1f5f9',
                      border: '1px solid #e2e8f0',
                      color: '#64748b',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '20px',
                      fontWeight: '400'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#e2e8f0';
                      e.currentTarget.style.borderColor = '#cbd5e1';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#f1f5f9';
                      e.currentTarget.style.borderColor = '#e2e8f0';
                    }}
                  >
                    ×
                  </button>
                </div>
              </div>

              {/* Content */}
              <div style={{ padding: '24px' }}>
                <div style={{
                  background: '#f8fafc',
                  borderRadius: '12px',
                  padding: '20px',
                  marginBottom: '16px',
                  border: '1px solid #f1f5f9'
                }}>
                  <InputMUI
                    label="Loan Approved Amount"
                    variant="outlined"
                    name="loanAprrovedAmt"
                    id="loanAprrovedAmt"
                    type="number"
                    size="small"
                    required={true}
                    onChange={(value) =>
                      handleChange(value, "loanAprrovedAmt")
                    }
                    value={calculateProductPayload.loanAprrovedAmt}
                  />
                </div>

                <div style={{
                  background: '#f8fafc',
                  borderRadius: '12px',
                  padding: '20px',
                  marginBottom: '16px',
                  border: '1px solid #f1f5f9'
                }}>
                  <InputMUI
                    label="Count Infuse"
                    variant="outlined"
                    name="countInfuse"
                    id="countInfuse"
                    type="number"
                    size="small"
                    required={true}
                    onChange={(value) => handleChange(value, "countInfuse")}
                    value={calculateProductPayload.countInfuse}
                  />
                </div>

                <div style={{
                  background: '#f8fafc',
                  borderRadius: '12px',
                  padding: '20px',
                  marginBottom: '24px',
                  border: '1px solid #f1f5f9'
                }}>
                  <InputMUI
                    label="Count Schedule"
                    variant="outlined"
                    name="countSchedule"
                    id="countSchedule"
                    type="number"
                    size="small"
                    required={true}
                    onChange={(value) => handleChange(value, "countSchedule")}
                    value={calculateProductPayload.countSchedule}
                  />
                </div>

                {/* Actions */}
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '12px',
                  marginTop: '8px'
                }}>
                  <button
                    onClick={() => {
                      resetCalculation();
                    }}
                    style={{
                      flex: 1,
                      padding: '14px 24px',
                      background: '#f1f5f9',
                      color: '#64748b',
                      border: '1px solid #e2e8f0',
                      borderRadius: '12px',
                      fontSize: '14px',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      fontFamily: 'system-ui, -apple-system, sans-serif'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#e2e8f0';
                      e.currentTarget.style.borderColor = '#cbd5e1';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#f1f5f9';
                      e.currentTarget.style.borderColor = '#e2e8f0';
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleCalculate}
                    disabled={!isValidForm()}
                    style={{
                      flex: 1,
                      padding: '14px 24px',
                      background: isValidForm()
                        ? 'linear-gradient(135deg, #015c57, #0a7d75)'
                        : 'linear-gradient(135deg, #cbd5e1, #94a3b8)',
                      color: '#ffffff',
                      border: 'none',
                      borderRadius: '12px',
                      fontSize: '14px',
                      fontWeight: '600',
                      cursor: isValidForm() ? 'pointer' : 'not-allowed',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      fontFamily: 'system-ui, -apple-system, sans-serif',
                      boxShadow: isValidForm()
                        ? '0 4px 14px rgba(1, 92, 87, 0.3)'
                        : '0 2px 8px rgba(0, 0, 0, 0.1)',
                      letterSpacing: '0.025em',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => {
                      if (isValidForm()) {
                        e.currentTarget.style.background = 'linear-gradient(135deg, #0a7d75, #0e8d84)';
                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(1, 92, 87, 0.4)';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (isValidForm()) {
                        e.currentTarget.style.background = 'linear-gradient(135deg, #015c57, #0a7d75)';
                        e.currentTarget.style.boxShadow = '0 4px 14px rgba(1, 92, 87, 0.3)';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }
                    }}
                  >
                    {loader ? (
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                        <div style={{
                          width: '16px',
                          height: '16px',
                          border: '2px solid #ffffff',
                          borderTop: '2px solid transparent',
                          borderRadius: '50%',
                          animation: 'spin 1s linear infinite'
                        }}></div>
                        Calculating...
                      </div>
                    ) : 'Calculate'}
                  </button>
                </div>
              </div>

              {/* Loading Overlay */}
              {loader && (
                <div style={{
                  position: 'absolute',
                  inset: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 1002,
                  borderRadius: '16px',
                  backdropFilter: 'blur(4px)'
                }}>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <div style={{
                      width: '40px',
                      height: '40px',
                      border: '3px solid #f1f5f9',
                      borderTop: '3px solid #015c57',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></div>
                    <div style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#64748b'
                    }}>Calculating...</div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
              @keyframes modalSlideIn {
                from {
                  opacity: 0;
                  transform: scale(0.95) translateY(-20px);
                }
                to {
                  opacity: 1;
                  transform: scale(1) translateY(0);
                }
              }
            `}
          </style>
        </>
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default BudgetPlanning;
